import React, { createContext, useContext } from 'react';

const ComponentRegistryContext = createContext({});

export const ComponentRegistryProvider = ({ children, components={} }) => {
    return (
        <ComponentRegistryContext.Provider value={{ components }}>
            {children}
        </ComponentRegistryContext.Provider>
    );
};

export const useComponentRegistry = () => useContext(ComponentRegistryContext);
